import { Box, IconButton, InputAdornment, TextField, Typography, Button, Stack, Collapse, Badge } from "@mui/material"
import { Close, Search } from "@mui/icons-material"
import { useTranslation } from "react-i18next"
import { useState, forwardRef } from "react"
import { useIsMobile } from "../hooks/mobile"

const CustomToolbar = forwardRef(
  (
    {
      search,
      setSearch,
      count,
      children,
      clearFilters,
      filtersCount = 0,
    }: {
      search: string
      setSearch: (search: string) => void
      count?: number
      children?: React.ReactNode
      clearFilters?: () => void
      filtersCount?: number
    },
    ref
  ) => {
    const { t } = useTranslation()
    const [filtersOpen, setFiltersOpen] = useState(false)
    const isMobile = useIsMobile()

    return (
      <Box ref={ref}>
        <Collapse in={filtersOpen}>
          <Box sx={{ p: 2 }}>{children}</Box>
        </Collapse>
        <Box
          sx={{
            display: "flex",
            justifyContent: "space-between",
            alignItems: "center",
            px: 2,
            pt: 0,
          }}
        >
          {!isMobile && (
            <Stack sx={{ flexGrow: 1 }} direction="row">
              {!!children && (
                <>
                  <Button onClick={() => setFiltersOpen(!filtersOpen)}>
                    <Badge badgeContent={filtersCount} color="primary">
                      {t("general.filtri")}
                    </Badge>
                  </Button>
                  {filtersCount > 0 && (
                    <Button onClick={clearFilters} sx={{ ms: 2 }}>
                      {t("general.elimina_filtri")}
                    </Button>
                  )}
                </>
              )}
            </Stack>
          )}
          <Box alignItems={"center"} display={"flex"} justifyContent={"center"} sx={{ mt: 2, mb: 1 }}>
            {!!count && (
              <Typography
                variant="body2"
                sx={{
                  mx: 2,
                }}
              >
                {count} {t("general.items")}
              </Typography>
            )}
            <TextField
              sx={{ width: isMobile ? 180 : 240, m: 0 }}
              // label="Cerca"
              variant="standard"
              size="small"
              margin="normal"
              placeholder={t("general.cerca")}
              value={search}
              onChange={(e) => setSearch(e.target.value)}
              slotProps={{
                input: {
                  endAdornment: (
                    <InputAdornment position="end">
                      <IconButton
                        onClick={() => setSearch("")}
                        size="small"
                        disabled={!search}
                        aria-label={t("accessibility.pulisci_ricerca")}
                      >
                        <Close sx={{ opacity: search ? 1 : 0 }} />
                      </IconButton>
                    </InputAdornment>
                  ),
                  startAdornment: (
                    <InputAdornment position="start">
                      <Search />
                    </InputAdornment>
                  ),
                },
              }}
            />
          </Box>
        </Box>
      </Box>
    )
  }
)

export default CustomToolbar
